@if (noAccount()) {
  <div class="tw-flex tw-flex-col tw-items-center tw-pt-6">
    <h1 class="tw-m-0 tw-text-center tw-font-rubik tw-text-xl tw-font-medium tw-leading-none tw-text-black">
      {{ 'auth_login.sso.no_account_title' | translate }}
    </h1>

    <p class="tw-mb-0 tw-mt-[33px] tw-max-w-[461px] tw-text-center tw-font-rubik tw-text-base tw-leading-snug">
      {{ 'auth_login.sso.no_account_explain' | translate: { email: email() } }}
    </p>

    <p class="tw-mb-0 tw-mt-[18px] tw-max-w-[461px] tw-text-center tw-font-rubik tw-text-base tw-leading-snug">
      {{ 'auth_login.sso.no_account_contact' | translate }}
    </p>

    <div class="tw-mt-[29px]">
      <mh-core-lib-button
        [isPrimary]="true"
        [text]="'auth_login.sso.back_home' | translate"
        customClass="!tw-w-auto !tw-min-w-[150px] tw-whitespace-nowrap"
        textClass="tw-font-rubik"
        (clicked)="backClicked.emit()"
      ></mh-core-lib-button>
    </div>
  </div>
} @else {
  <div class="tw-flex tw-flex-col tw-items-center tw-pt-6">
    <mh-auth-form-header titleKey="auth_login.welcome" explainKey="auth_login.sso.explain"></mh-auth-form-header>

    <div class="tw-mt-[35px]">
      <mh-core-lib-button
        [isSecondary]="true"
        [icon]="providerIcon()"
        [isDisabled]="loading()"
        [isDownloading]="loading()"
        [text]="'auth_login.sso.continue_with' | translate: { provider: providerLabel() }"
        customClass="!tw-w-auto !tw-min-w-[240px] tw-whitespace-nowrap"
        loaderClass="tw-mx-auto"
        textClass="tw-font-rubik"
        (clicked)="continueClicked.emit()"
      ></mh-core-lib-button>
    </div>

    @if (errorKey()) {
      <p class="tw-mb-0 tw-mt-[14px] tw-max-w-[417px] tw-text-center tw-font-rubik tw-text-sm tw-text-red-500">
        {{ errorKey() | translate }}
      </p>
    }

    <button
      type="button"
      class="tw-mt-[26px] tw-border-0 tw-bg-transparent tw-p-0 tw-font-rubik tw-text-sm tw-text-main-text tw-underline disabled:tw-cursor-not-allowed disabled:tw-text-disabled-font"
      [disabled]="loading()"
      (click)="backClicked.emit()"
    >
      <i class="far fa-arrow-left tw-mr-1"></i>{{ 'auth_login.back' | translate }}
    </button>
  </div>
}
